// * This provides a seamless zooming experience without any additional user interaction like pinch-to-zoom.
//  * Dynamic styling is applied via inline styles for the zoom behavior, while static styling is managed using Tailwind CSS.
//  */

import React, { useState } from 'react';

interface MagnifierProps {
  src: string | undefined;
}

const Magnifier = ({ src }: MagnifierProps) => {
  const [magnifierVisible, setMagnifierVisible] = useState(false);
  const [backgroundPosition, setBackgroundPosition] = useState('0% 0%');

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const { top, left, width, height } = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setBackgroundPosition(`${x}% ${y}%`);
  };

  return (
    <div
      className="aspect-square relative flex h-[100%] w-[100%] max-w-none justify-center"
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setMagnifierVisible(true)}
      onMouseLeave={() => setMagnifierVisible(false)}
    >
      {/* Main image */}
      <img src={src} alt="Magnifiable" className="aspect-square w-[100%] object-cover" />

      {/* Magnifier overlay */}
      {magnifierVisible && (
        <div
          className="pointer-events-none absolute inset-0 bg-no-repeat"
          style={{
            backgroundImage: `url(${src})`,
            backgroundPosition: backgroundPosition,
            backgroundSize: '200% 200%',
          }}
        ></div>
      )}
    </div>
  );
};

export default Magnifier;
